"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = exports.CloseButton = exports.Footer = exports.CloseIcon = exports.StyledIcon = exports.Content = exports.Header = exports.ModalContent = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _borderRadius = require("../../utils/borderRadius");

var _mediaQueries = _interopRequireDefault(require("../../utils/media-queries"));

var _Button = _interopRequireDefault(require("../Button"));

var _H = _interopRequireDefault(require("../Typography/H4"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _utils = require("./utils");

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    width: 100%;\n    margin-right: 0;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    width: 100%;\n    margin-top: 12px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    align-items: center;\n    flex-direction: column;\n    padding: 30px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 42px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    background: ", "; \n    margin-left: 32px;\n    position: absolute;\n    right: 12px;\n    top: 12px;\n    z-index: 2;\n\n    &:hover {\n      box-shadow: none;\n    }\n\n    ", " {\n      fill: ", ";\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 0 30px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 30px 30px 18px 30px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 42px 102px 24px 42px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    max-width: 672px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    border-radius: 0;\n    width: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      ", "\n   "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getWidth = function getWidth(size) {
  switch (size) {
    case 'thin':
      return '378';

    case 'compact':
      return '588';

    case 'wide':
      return '882';

    default:
      return '882';
  }
};

var ModalContent = _styledComponents["default"].div.withConfig({
  displayName: "styled__ModalContent",
  componentId: "sc-1vy8exk-0"
})(["", " background:", ";display:flex;flex-direction:column;justify-content:space-between;position:relative;z-index:11;width:", "px;", " ", ""], _borderRadius.borderRadiusLarge.all, function (_ref) {
  var theme = _ref.theme;
  return theme.color.background;
}, function (props) {
  return getWidth(props.size);
}, _mediaQueries["default"].tablet(_templateObject(), function (_ref2) {
  var size = _ref2.size;
  return !(0, _utils.isSetSize)(size) && "\n        width: 80vw;\n      ";
}), _mediaQueries["default"].mobile(_templateObject2()));

exports.ModalContent = ModalContent;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "styled__Header",
  componentId: "sc-1vy8exk-1"
})(["align-items:center;display:flex;flex:0 0 auto;min-height:60px;justify-content:space-between;padding:42px 42px ", "px;", "{font-weight:700;}", " ", " ", ""], function (props) {
  return (0, _utils.isCompact)(props.size) ? '18' : '30';
}, _H["default"], _mediaQueries["default"].desktop(_templateObject3()), _mediaQueries["default"].tablet(_templateObject4()), _mediaQueries["default"].mobile(_templateObject5()));

exports.Header = Header;

var Content = _styledComponents["default"].div.withConfig({
  displayName: "styled__Content",
  componentId: "sc-1vy8exk-2"
})(["align-items:flex-start;display:flex;flex-grow:1;margin-bottom:18px;padding:0 42px;", ""], _mediaQueries["default"].mobile(_templateObject6()));

exports.Content = Content;
var StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styled__StyledIcon",
  componentId: "sc-1vy8exk-3"
})(["cursor:pointer;"]);
exports.StyledIcon = StyledIcon;
var CloseIcon = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "styled__CloseIcon",
  componentId: "sc-1vy8exk-4"
})(["background:", ";position:", ";right:", "px;top:", "px;&:hover{background:", ";box-shadow:none;}&:focus{background:", ";box-shadow:none;}", ""], function (_ref3) {
  var modalSize = _ref3.modalSize,
      theme = _ref3.theme;
  return (0, _utils.isCompact)(modalSize) ? theme.color.miscLightest : 'none';
}, function (props) {
  return (0, _utils.isCompact)(props.modalSize) ? 'absolute' : 'fixed';
}, function (props) {
  return (0, _utils.isCompact)(props.modalSize) ? '12' : '4';
}, function (props) {
  return (0, _utils.isCompact)(props.modalSize) ? '12' : '5';
}, function (_ref4) {
  var modalSize = _ref4.modalSize,
      theme = _ref4.theme;
  return (0, _utils.isCompact)(modalSize) ? theme.color.miscLighter : 'none';
}, function (_ref5) {
  var modalSize = _ref5.modalSize,
      theme = _ref5.theme;
  return (0, _utils.isCompact)(modalSize) ? theme.color.miscLightest : 'none';
}, _mediaQueries["default"].handheld(_templateObject7(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.miscLightest;
}, StyledIcon, function (_ref7) {
  var modalSize = _ref7.modalSize,
      theme = _ref7.theme;
  return (0, _utils.isCompact)(modalSize) ? theme.color.miscDarkest : theme.color.primaryDarkest;
}));
exports.CloseIcon = CloseIcon;

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "styled__Footer",
  componentId: "sc-1vy8exk-5"
})(["display:flex;padding:", "px 42px;", " ", ""], function (props) {
  return (0, _utils.isCompact)(props.size) ? '18' : '42';
}, _mediaQueries["default"].tablet(_templateObject8()), _mediaQueries["default"].mobile(_templateObject9()));

exports.Footer = Footer;
var CloseButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "styled__CloseButton",
  componentId: "sc-1vy8exk-6"
})(["", ""], _mediaQueries["default"].mobile(_templateObject10()));
exports.CloseButton = CloseButton;
var SubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "styled__SubmitButton",
  componentId: "sc-1vy8exk-7"
})(["margin-right:24px;", ""], _mediaQueries["default"].mobile(_templateObject11()));
exports.SubmitButton = SubmitButton;